<script>
    import TicketPluginSlider from "./TicketPluginSlider.svelte"
    import TicketPluginCheckBox from "./TicketPluginCheckBox.svelte"

    const controlTypes = {
        slider: TicketPluginSlider,
        checkbox: TicketPluginCheckBox
    }

	import { afterUpdate } from 'svelte'

    function copyParams(obj) {
        return {...obj}
    }

    export let params = {}
    let modifiedParams = copyParams(params)

    let pluginSettings = {}
    fetch("ticket-plugin-settings.json")
        .then(response => response.json())
        .then(data => pluginSettings = data)
        .then(updateAutocompleteData)
    
    // Awards for specific purchases in BANK and so on
    $: presets = pluginSettings.presets ?? {}
    let selectedPreset = ""
 
    $: items = pluginSettings.items ?? {}
    
    function onPresetSelected() {
        modifiedParams = copyParams(presets[selectedPreset] ?? {})
    }

    function onOk() {
        // Wait fade out
        setTimeout(() => { 
            params = copyParams(modifiedParams)
        }, 400)
    }

    function onCancel() {
        selectedPreset = ""
        modifiedParams = copyParams(params) 
    }

    function buildAutocompleteData() {
        const names = Object.keys(items)
        const entries = names.map(name => [name, `items/${name}.png`])
        return Object.fromEntries(entries)
    }

    let autocompleteInstances = []
    function updateAutocompleteData() {
        autocompleteInstances.forEach(instance => {
            instance.updateData(buildAutocompleteData());
        })
    }

	afterUpdate(async () => {
        let elems = document.querySelectorAll('select')
        let instances = M.FormSelect.init(elems)

        elems = document.querySelectorAll('.autocomplete')
        autocompleteInstances = M.Autocomplete.init(elems, {
            data: buildAutocompleteData(),
            onAutocomplete: paramName => {
                console.log("onAutocomplete", paramName)
                modifiedParams[paramName] = items[paramName]?.step ?? 1
            }
        })        
    })    
</script>


<div class="modal-content">
    <div>
        <div class="input-field">
            <i class="material-icons prefix">storage</i>
            <select id="presets-list" bind:value={selectedPreset} on:change={onPresetSelected}>
                {#each ["<None>", ...Object.keys(presets)] as preset}
                    <option>{preset}</option>
                {/each}
            </select>
            <label for="presets-list">Select preset</label>
        </div>
        <div class="input-field">
            <i class="material-icons prefix">edit</i>
            <input type="text" id="insert-param" class="autocomplete">
            <label for="insert-param">Insert parameter</label>
        </div>
    </div>

    <div>
        {#each Object.keys(modifiedParams) as name}
            <svelte:component this={controlTypes[items[name].type]} bind:value={modifiedParams[name]} name={name} items={items} />
        {/each}
    </div>
</div>

<div class="modal-footer">
    <!-- svelte-ignore a11y-missing-attribute -->
    <a class="modal-close waves-effect waves btn" on:click={onOk}>OK</a>
    <!-- svelte-ignore a11y-missing-attribute -->
    <a class="modal-close waves-effect waves btn-flat" on:click={onCancel}>Cancel</a> 
</div>


<style>
    .modal-content {
        padding-left: 5%;
        padding-right: 5%;
        padding-top: 25px;
        padding-bottom: 10px;
        min-height: 500px;
    }
</style>